var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"home"},[_c('v-row',[_c('v-col',{staticClass:"text-center text-h4 pt-10",attrs:{"cols":"12"}},[_c('img',{attrs:{"src":require("../assets/mamaroz-logo.png"),"height":"200"}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }